import { useEffect } from 'react'
import { useLocalStorage } from '../remote/local-storage'
import { useNavigateRoute } from '../view/hooks/navigation'
import { RoutesPath } from './routes-path'

interface RouteProvideProps {
  element: any
}
export const RouteProviderProtect = ({ element }: RouteProvideProps) => {
  const { useFetchLocalStore } = useLocalStorage()
  const { navigateTo } = useNavigateRoute()

  useEffect(() => {
    if (!useFetchLocalStore()) navigateTo(RoutesPath.login)
  }, [])

  return element
}
